import type React from "react";
import type { NavigateOptions } from "react-router-dom";

import { RouterProvider, ToastProvider } from "@heroui/react";
import { useHref, useNavigate } from "react-router-dom";

declare module "react-aria-components" {
  interface RouterConfig {
    routerOptions: NavigateOptions;
  }
}

export function HeroProvider({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();

  return (
    <RouterProvider navigate={navigate} useHref={useHref}>
      <ToastProvider placement="top end" />
      {children}
    </RouterProvider>
  );
}
